import { Col, Form, Row } from "react-bootstrap";
import ColorInput from "../ColorInput";
import FileInput from "../FileInput";
import ColorPickerClose from "../ColorPickerClose";
import ColorPickerAdd from "../ColorPickerAdd";

const FontsContent = ({
  formData,
  setFormData,
  onInputChange,
  handleFileChange,
  fileNames,
  files,
  validate,
}) => {
  const gradientOptions = [
    { value: 1, label: "Top to Bottom" },
    { value: 2, label: "Left to Right" },
    { value: 3, label: "Top Left to Bottom Right" },
    { value: 4, label: "Top Right to Bottom Left" },
  ];

  const addBgColor = (keyName) => {
    setFormData((prev) => ({
      ...prev,
      fontsContent: {
        ...prev.fontsContent,
        [keyName]: [...prev.fontsContent[keyName], "#000000"],
      },
    }));
  };

  const removeBgColor = (keyName, index) => {
    setFormData((prev) => {
      const updatedBgColors = prev.fontsContent[keyName].filter(
        (_, i) => i !== index
      );
      return {
        ...prev,
        fontsContent: {
          ...prev.fontsContent,
          [keyName]: updatedBgColors,
          bgColorOrientation:
            updatedBgColors.length === 1
              ? null
              : prev.fontsContent.bgColorOrientation,
        },
      };
    });
  };
  return (
    <Row className="g-3">
      <Col md={3}>
        <ColorInput
          label="Separator Color"
          name="fontsContent.separatorColor"
          value={formData.fontsContent.separatorColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Font Text Normal Color"
          name="fontsContent.textNormalColor"
          value={formData.fontsContent.textNormalColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Font Text Selected Color"
          name="fontsContent.textSelectedColor"
          value={formData.fontsContent.textSelectedColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Opacity (Ex., 0.5)</Form.Label>
          <Form.Control
            type="text"
            name="fontsContent.opacity"
            value={formData.fontsContent.opacity}
            onChange={onInputChange}
            min={0}
            max={1}
            className="my-2"
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <ColorInput
          label="Font Selected Border Color"
          name="fontsContent.selectedBorderColor"
          value={formData.fontsContent.selectedBorderColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Font Selected Border Width (px)</Form.Label>
          <Form.Control
            type="number"
            name="fontsContent.selectedBorderWidth"
            className="my-2"
            value={formData.fontsContent.selectedBorderWidth}
            onChange={onInputChange}
            min={0}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Normal Border Width (px)</Form.Label>
          <Form.Control
            type="number"
            name="fontsContent.normalBorderWidth"
            className="my-2"
            value={formData.fontsContent.normalBorderWidth}
            onChange={onInputChange}
            min={0}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <ColorInput
          label="Normal Border Color"
          name="fontsContent.normalBorderColor"
          value={formData.fontsContent.normalBorderColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <div className="d-flex align-items-center gap-4">
          <Form.Label>Font Normal Background Color</Form.Label>
          <ColorPickerAdd addBgColor={addBgColor} keyName="normalBgColor" />
        </div>
        <div className="d-flex align-items-center gap-3">
          {formData.fontsContent.normalBgColor.map((color, index) => (
            <div key={index} className="position-relative">
              <ColorInput
                name="fontsContent.normalBgColor"
                value={color}
                data-index={index}
                onChange={onInputChange}
              />

              {formData.fontsContent.normalBgColor.length > 1 && (
                <ColorPickerClose
                  removeBgColor={removeBgColor}
                  index={index}
                  keyName="normalBgColor"
                />
              )}
            </div>
          ))}
        </div>
      </Col>
      {formData.fontsContent.normalBgColor.length > 1 && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Normal Background Gradient Orientation</Form.Label>
            <Form.Select
              name="fontsContent.bgColorOrientation"
              value={formData.fontsContent.bgColorOrientation || ""}
              onChange={onInputChange}
              className="my-2"
              required={formData.fontsContent.normalBgColor.length > 1}
            >
              <option value="">Select Orientation</option>
              {gradientOptions.map((orientation) => (
                <option key={orientation.value} value={orientation.value}>
                  {orientation.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}
      {/* <Col md={3}>
        <Form.Group>
          <Form.Label htmlFor="bgType">
            Font Selected Background Type
          </Form.Label>
          <Form.Select
            name="fontsContent.bgType"
            value={formData.fontsContent.bgType || "color"}
            onChange={onInputChange}
            className="my-2"
          >
            <option value="color">Color</option>
            <option value="image">Image</option>
          </Form.Select>
        </Form.Group>
      </Col> */}
      {/* {formData.fontsContent.bgType === "image" && (
        <Col md={3}>
          <FileInput
            label="Font Selected Background Image"
            name="fontsContentImage"
            onChange={handleFileChange}
            accept="image/*"
            fileName={fileNames.fontsContentImage}
          />
        </Col>
      )}
      {formData.fontsContent.bgType === "color" && (
        <Col md={3}>
          <div className="d-flex align-items-center gap-4">
            <Form.Label>Font Selected Background Color</Form.Label>
            <ColorPickerAdd addBgColor={addBgColor} keyName="selectedBgColor" />
          </div>
          <div className="d-flex align-items-center gap-3">
            {formData.fontsContent.selectedBgColor.map((color, index) => (
              <div key={index} className="position-relative">
                <ColorInput
                  name="fontsContent.selectedBgColor"
                  value={color}
                  data-index={index}
                  onChange={onInputChange}
                />
                {formData.fontsContent.selectedBgColor.length > 1 && (
                  <ColorPickerClose
                    removeBgColor={removeBgColor}
                    index={index}
                    keyName="selectedBgColor"
                  />
                )}
              </div>
            ))}
          </div>
        </Col>
      )} */}
      {formData.fontsContent.bgType === "color" && (
        <Col md={3}>
          <div className="d-flex align-items-center gap-4">
            <Form.Label>Font Selected Background Color</Form.Label>
            <ColorPickerAdd addBgColor={addBgColor} keyName="selectedBgColor" />
          </div>
          <div className="d-flex align-items-center gap-3">
            {formData.fontsContent.selectedBgColor.map((color, index) => (
              <div key={index} className="position-relative">
                <ColorInput
                  name="fontsContent.selectedBgColor"
                  value={color}
                  data-index={index}
                  onChange={onInputChange}
                />
                {formData.fontsContent.selectedBgColor.length > 1 && (
                  <ColorPickerClose
                    removeBgColor={removeBgColor}
                    index={index}
                    keyName="selectedBgColor"
                  />
                )}
              </div>
            ))}
          </div>
        </Col>
      )}
      {formData.fontsContent.selectedBgColor.length > 1 && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Selected Background Gradient Orientation</Form.Label>
            <Form.Select
              name="fontsContent.selectedBgOrientation"
              value={formData.fontsContent.selectedBgOrientation || ""}
              onChange={onInputChange}
              className="my-2"
              required={formData.fontsContent.selectedBgColor.length > 1}
            >
              <option value="">Select Orientation</option>
              {gradientOptions.map((orientation) => (
                <option key={orientation.value} value={orientation.value}>
                  {orientation.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}
      <Col md={3}>
        <FileInput
          label="Font Selected Icon Image"
          name="fontsContentSelectionIconImage"
          onChange={handleFileChange}
          required={true}
          fileName={fileNames.fontsContentSelectionIconImage}
          accept="image/*"
          isInvalid={validate && !files.fontsContentSelectionIconImage}
          feedback="Upload a selection icon image."
        />
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Corner Radius (px)</Form.Label>
          <Form.Control
            type="number"
            name={`fontsContent.corners`}
            value={formData.fontsContent?.corners || 0}
            onChange={onInputChange}
            min={0}
            className="my-2"
          />
        </Form.Group>
      </Col>

      <Col md={12} className="mt-4">
        <h5 className="fw-bold">GIF Category</h5>
        <Row className="g-3">
          <Col md={3}>
            <ColorInput
              label="Search Icon Color"
              name="fontsContent.gifCategoryData.searchIconColor"
              value={formData.fontsContent.gifCategoryData.searchIconColor}
              onChange={onInputChange}
            />
          </Col>
          <Col md={3}>
            <ColorInput
              label="Search Text Color"
              name="fontsContent.gifCategoryData.searchTextColor"
              value={formData.fontsContent.gifCategoryData.searchTextColor}
              onChange={onInputChange}
            />
          </Col>
          <Col md={3}>
            <ColorInput
              label="Search Background Color"
              name="fontsContent.gifCategoryData.searchBackgroundColor"
              value={
                formData.fontsContent.gifCategoryData.searchBackgroundColor
              }
              onChange={onInputChange}
            />
          </Col>
          <Col md={3}>
            <ColorInput
              label="Search Border Color"
              name="fontsContent.gifCategoryData.searchBorderColor"
              value={formData.fontsContent.gifCategoryData.searchBorderColor}
              onChange={onInputChange}
            />
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Search Opacity (Ex., 0.5)</Form.Label>
              <Form.Control
                type="text"
                name="fontsContent.gifCategoryData.searchOpacity"
                value={formData.fontsContent.gifCategoryData.searchOpacity}
                onChange={onInputChange}
                min={0}
                max={1}
                className="my-2"
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <FileInput
              label="GIF Back Icon Image"
              name="gifBackImage"
              onChange={handleFileChange}
              accept="image/*"
              fileName={fileNames.gifBackImage}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default FontsContent;
